<template>
  <nav aria-label="Page navigation example">
    <ul class="pagination">
      <li class="page-item">
        <a class="page-link" href="#" aria-label="Previous" @click.prevent="prev">
          <span aria-hidden="true">&laquo; <span>Previous</span></span>
        </a>
      </li>
      <li class="page-item">
        <a class="page-link" href="#" aria-label="Next" @click.prevent="next">
          <span aria-hidden="true"><span>Next</span> &raquo;</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Pagination',
  props: ['collection', 'collectionName', 'limit', 'gameSlug'],
  created() {
    this.getData();
  },
  beforeDestroy() {
    this.resetData();
  },
  methods: {
    resetData() {
      if (typeof this.unsub !== 'undefined') {
        this.unsub();
      }
    },
    getData() {
      this.resetData();
      const db = window.firebase.firestore();
      const colRef = db.collection(this.collectionName);
      const query = colRef
        .where('game', '==', this.gameSlug)
        .where('lobby', '==', true)
        .where('playerCount', '==', 1)
        .orderBy('createdAt', 'desc')
        .limit(this.limit || 2);

      const onDataArrival = (querySnapshot) => {
        this.innerCol = [];
        [this.first] = querySnapshot.docs;
        this.last = querySnapshot.docs[querySnapshot.docs.length - 1];

        querySnapshot.forEach((doc) => {
          this.innerCol.push({ id: doc.id, ...doc.data() });
        });
        this.$emit('on-page-change', this.innerCol);
      };

      this.unsub = query.onSnapshot(onDataArrival);
    },
    prev() {
      if (this.innerCol.length === 0) {
        this.getData();
      } else {
        this.resetData();
        const db = window.firebase.firestore();
        const colRef = db.collection(this.collectionName);
        const query = colRef
          .where('game', '==', this.gameSlug)
          .where('lobby', '==', true)
          .where('playerCount', '==', 1)
          .orderBy('createdAt', 'asc')
          .startAfter(this.first)
          .limit(this.limit || 2);

        this.unsub = query.onSnapshot((querySnapshot) => {
          this.innerCol = [];
          [this.last] = querySnapshot.docs;
          this.first = querySnapshot.docs[querySnapshot.docs.length - 1];

          querySnapshot.forEach((doc) => {
            this.innerCol.unshift({ id: doc.id, ...doc.data() });
          });
          this.$emit('on-page-change', this.innerCol);
        });
      }
    },
    next() {
      if (this.innerCol.length === 0) {
        this.getData();
      } else {
        this.resetData();
        const db = window.firebase.firestore();
        const colRef = db.collection(this.collectionName);
        const query = colRef
          .where('game', '==', this.gameSlug)
          .where('lobby', '==', true)
          .where('playerCount', '==', 1)
          .orderBy('createdAt', 'desc')
          .startAfter(this.last)
          .limit(this.limit || 2);

        this.unsub = query.onSnapshot((querySnapshot) => {
          this.innerCol = [];
          [this.first] = querySnapshot.docs;
          this.last = querySnapshot.docs[querySnapshot.docs.length - 1];

          querySnapshot.forEach((doc) => {
            this.innerCol.push({ id: doc.id, ...doc.data() });
          });
          this.$emit('on-page-change', this.innerCol);
        });
      }
    },
  },
  data() {
    return {
      unsub: undefined,
      first: {},
      last: {},
      innerCol: [],
    };
  },
};
</script>

<style scoped lang="scss">
// @import "../styles/_vars.scss";
</style>
